<template>
    <div class="steps-box">
        <el-steps v-if="show" :active="active" align-center>
            <el-step v-for="(item, index) in stpesOptions" :key="item.value" :status="item.status">
                <template #icon>
                    <el-button round @click="next(index)">{{ index + 1 }}</el-button>
                </template>
                <template #title>
                    <span @click="next(index)">{{ item.title }}</span>
                </template>
            </el-step>
            <!-- <el-step title="项目立项">
                <template #title>
                    <span @click="next('1')">项目立项</span>
                </template>
            </el-step>
            <el-step>
                <template #title>
                    <span @click="next('2')">投标保证金申请</span>
                </template>
            </el-step>
            <el-step>
                <template #title>
                    <span @click="next('3')">标书制作费</span>
                </template>
            </el-step>
            <el-step title="开标登记">
                <template #title>
                    <span @click="next('4')">开标登记</span>
                </template>
            </el-step>

            <el-step title="结果登记">
                <template #title>
                    <span @click="next('5')">结果登记</span>
                </template>
            </el-step>
                <template #title>
                    <span @click="next('6')">中标服务费</span>
                </template>
            </el-step>
            <el-step title="投票结束">
                <template #title>
                    <span @click="next('7')">投票结束</span>
                </template>
            </el-step> -->
        </el-steps>
    </div>
</template>

<script>
export default {
    name: 'InputWithHistory',
    props: {
        vo: {
            type: Object,
            default: () => ({})
        },
        arr: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            active: 0,
            show: true,
            stpesOptions: [
                {
                    title: '项目立项',
                    value: 0,
                    status: 'wait '
                },
                {
                    title: '投标保证金申请',
                    value: 1,
                    status: 'wait '
                },
                {
                    title: '标书制作费',
                    value: 2,
                    status: 'wait '
                },
                {
                    title: '开标登记',
                    value: 3,
                    status: 'wait '
                },
                {
                    title: '结果登记',
                    value: 4,
                    status: 'wait '
                },
                {
                    title: '中标服务费',
                    value: 5,
                    status: 'wait '
                }
            ]
        }
    },
    watch: {},
    created() {},
    mounted() {
        if (this.vo.status < 2) {
            this.$set(this.stpesOptions[0], 'status', 2)
        } else {
            this.$set(this.stpesOptions[0], 'status', 1)
        }
    },
    methods: {
        setStepOptions(arr) {
            this.arr = arr

            this.stpesOptions.forEach((opt, index) => {
                if (index > 0) opt.status = 'wait'
            })

            let last = 0
            arr.forEach((data, index) => {
                if (data) {
                    if (data.status < 2) {
                        this.$set(this.stpesOptions[index], 'status', 1)
                    } else {
                        this.$set(this.stpesOptions[index], 'status', 2)
                    }
                    last = index
                }
            })

            if (last > 0 && this.$route.query.steps === undefined) {
                this.$emit('stepsClick', last)
            }
        },
        next(index) {
            this.setStepOptions(this.arr)

            if (index > 0 && index < 6) this.$set(this.stpesOptions[index], 'status', 'process')
            this.$emit('stepsClick', index)
        }
    }
}
</script>

<style scoped lang="scss">
.steps-box {
    padding: 20px;

    :deep(.el-step) {
        cursor: pointer;

        .is-process {
            color: var(--subjectColor);
        }

        .is-text {
            border-color: initial;
        }
    }

    /deep/ .is-round {
        padding: 10px 12px;
        border-radius: 50% !important;
    }
}
</style>
